<div
    *ngIf="!isChild"
    class="d-md-flex justify-content-between align-items-center"
    [style.width]="chartWidth"
>
    <div>
        <p *ngIf="!isChild" class="text-secondary">{{ description }}</p>
        <form [formGroup]="form" class="d-md-flex">
            <mat-form-field appearance="fill" class="flex-fill me-md-2">
                <mat-label>By</mat-label>
                <mat-select
                    formControlName="typeCtrl"
                    sbTestSelector="value-bridge-type"
                    omitInnerText="true"
                >
                    <mat-option
                        *ngFor="let type of types; let i = index"
                        [value]="type.value"
                    >
                        {{ type.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="flex-fill ms-md-2">
                <mat-label>From and to date</mat-label>
                <mat-date-range-input [rangePicker]="dp" [formGroup]="form">
                    <input
                        matStartDate
                        formControlName="fromDate"
                        placeholder="From date"
                        (click)="dp.open()"
                    />
                    <input
                        matEndDate
                        formControlName="toDate"
                        placeholder="To date"
                        (click)="dp.open()"
                    />
                </mat-date-range-input>
                <mat-hint>Select from and to date</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="dp">
                    <i-tabler matDatepickerToggleIcon name="calendar"></i-tabler>
                </mat-datepicker-toggle>
                <mat-date-range-picker #dp></mat-date-range-picker>
            </mat-form-field>
        </form>
    </div>
    <div *ngIf="graphData$ | async as graphData" class="mt-3 mt-md-0">
        <!--<div class="right">
            <button
                type="button"
                class="btn btn-link m-n3 text-primary"
                [matMenuTriggerFor]="horizontalLayoutContextMenu"
            >
                <tabler-icon name="dots"></tabler-icon>
            </button>
            <mat-menu #horizontalLayoutContextMenu="matMenu">
                <button
                    type="button"
                    class="d-inline-flex align-items-center"
                    mat-menu-item
                    (click)="toggleShortNumberFormat()"
                >
                    <tabler-icon
                        class="me-2"
                        style="height: 20px; width: 20px; display: inline-flex"
                        [name]="useShortNumberFormat ? 'error-404-off' : '123'"
                    ></tabler-icon>
                    {{ useShortNumberFormat ? 'Use regular numbers' : 'Use short numbers' }}
                </button>
            </mat-menu>
        </div>-->
        <sb-key-metrics [metrics]="metrics$ | async"></sb-key-metrics>
    </div>
</div>
<div class="overflow-x-auto-hover">
    <div
        class="chart-container"
        [style.height]="containerHeight + 'px'"
        [style.margin-top]="isChild ? 0 : '3rem'"
        @list
    >
        <ng-container
            *ngIf="(loading$ | async) === false && (graphData$ | async) as graphData"
        >
            <div
                *ngFor="
                    let item of graphData.graph;
                    let i = index;
                    let first = first;
                    let last = last
                "
                class="bar"
                @fadeInOut
                [class.positive]="item.value > 0"
                [class.negative]="item.value < 0"
                [class.date]="first || last"
                [class.clickable-bar]="
                    !isChild && !first && !last && item['pretty_name'] !== 'Other'
                "
                [ngStyle]="barStyles[i]"
                (click)="
                    !isChild &&
                    i !== 0 &&
                    i !== graphData.graph.length - 1 &&
                    item['pretty_name'] !== 'Other'
                        ? onBarClick(item.group)
                        : null
                "
                [matTooltip]="
                    !isChild && item['pretty_name'] === 'Other'
                        ? 'No underlying data available'
                        : ''
                "
            >
                <span class="value-label">{{ item.value | number : '1.0-0' }}</span>

                <span class="label" [style.top]="labelTopStyles[i]">
                    {{
                        item.pretty_name.length > 20
                            ? (item.pretty_name | slice : 0 : 17) + '...'
                            : item.pretty_name
                    }}
                </span>

                <div
                    *ngIf="i < graphData.graph.length - 1"
                    [ngStyle]="lineProperties[i]"
                ></div>
            </div>
            <div
                class="sb-value-bridge-chart-bottom-border"
                [style.width]="getBottomLineWidth()"
            ></div>
        </ng-container>

        <div
            aria-busy="true"
            class="table-loading skeleton-loader skeleton-loader-chart-bar"
            *ngIf="loading$ | async"
        >
            <span class="visually-hidden">Loading</span>
        </div>
    </div>
</div>

<!-- Overlay to capture click when child is displayed -->
<div class="overlay" *ngIf="showChildComponent" (click)="onOverlayClick()"></div>

<!-- Child Component -->
<sb-card-section
    *ngIf="showChildComponent"
    class="child"
    [title]="selectedParams.pretty_name"
    [style.width]="(chartWidth / 5) * 4 + 'px'"
    [style.height]="(containerHeight / 3) * 2 + 'px'"
>
    <sb-value-bridge-legacy
        [isChild]="true"
        [selectedParams]="selectedParams"
        [containerHeight]="(containerHeight / 3) * 2"
        [chartWidth]="(chartWidth / 100) * 88"
    ></sb-value-bridge-legacy>
</sb-card-section>
